module.exports = __webpack_public_path__ + "img/cut5img.9ae2f8dc.png";